export default "__VITE_ASSET__dd197650__"